import { Card, Typography, Badge } from "antd";
import "./HeroCard.scss";

const { Title, Text } = Typography;

export default function HeroCard({ token, icon, title, badge, description }) {
  return (
    <div className="hero-wrapper">
      <Card
        className="hero-card"
        style={{
          border: "none",
          background: `linear-gradient(135deg, ${token?.colorPrimary}08 0%, ${token?.colorSecondaryLogo}08 100%)`,
          borderRadius: 16,
          boxShadow: token?.HeroCard?.shadowLight,
        }}>
        <div className="hero-card__content">
          <div className="hero-card__header">
            <div
              className="hero-card__iconWrapper"
              style={{
                background: `linear-gradient(135deg, ${token?.colorPrimary} 0%, ${token?.colorSecondaryLogo} 100%)`,
                boxShadow: token?.HeroCard?.shadowMedium,
              }}>
              {icon}
            </div>
            <div className="hero-card__titleSection">
              <Title
                level={1}
                style={{
                  margin: 0,
                }}
                className="hero-card__titleSection__title">
                {title}
              </Title>
              {badge && (
                <Badge
                  count={badge}
                  style={{
                    backgroundColor: token?.colorPrimary,
                    fontSize: 12,
                    height: 24,
                    lineHeight: "24px",
                  }}
                />
              )}
            </div>
          </div>
          <div
            className="hero-card__divider"
            style={{ backgroundColor: token?.colorPrimary, opacity: 0.2 }}
          />
          <Text className="hero-card__description">{description}</Text>
        </div>
      </Card>
    </div>
  );
}
